/**
 * EditModes for Forms.
 * @hidden
 */
export enum EditModes {
    Edit = 0,
    Add = 1,
    Filter = 2
}
